import { createApi } from '@reduxjs/toolkit/query/react';
import { BENCHMARK_LIST_API } from 'services/constants';
import { rawBaseQuery } from 'services/shared';
import { BenchmarkListResponse } from 'services/types';

export const benchmarkApi = createApi({
  reducerPath: BENCHMARK_LIST_API,
  baseQuery: rawBaseQuery,
  endpoints: (builder) => ({
    getBenchmarkList: builder.query<BenchmarkListResponse[], string>({
      query: (valuationDate) =>
        encodeURI(`/benchmarks?valuationDate=${valuationDate}`),
    }),
  }),
});

export const { useGetBenchmarkListQuery } = benchmarkApi;
